import { render, staticRenderFns } from "./vRepContrato.vue?vue&type=template&id=159a542c&scoped=true&"
import script from "./vRepContrato.vue?vue&type=script&lang=js&"
export * from "./vRepContrato.vue?vue&type=script&lang=js&"
import style0 from "./vRepContrato.vue?vue&type=style&index=0&id=159a542c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a542c",
  null
  
)

export default component.exports